import React from 'react';
import Router from './config/Router/Router';
import StoreProvider from './store/StoreProvider';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ToastContainer } from 'react-toastify';

const App = () => (
  <GoogleOAuthProvider clientId="665225465200-si1p5vkq91dlvoeu4d8vhv94ls2ronl8.apps.googleusercontent.com">
    <StoreProvider>
      <Router />
      <ToastContainer />
    </StoreProvider>
  </GoogleOAuthProvider>
);

export default App;
